import { ColumnDef } from "@tanstack/react-table";
import { Button } from "@/shared/ui/button.tsx";
import { ArrowUpDown, Forward, Heart, TrendingUp } from "lucide-react";
import { format } from "date-fns";

export const AnalyticsColumn: ColumnDef<{
  post_id: number;
  event_name: string;
  event_type: string;
  likes: number;
  views: number;
  date_posted: string;
}>[] = [
    {
      accessorKey: "event_name",
      header: ({ column }) => {
        return (
          <span
            className=" flex flex-row bg-dacblue-light text-white cursor-pointer"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
            Event Name
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </span>
        );
      },
    },
    {
      accessorKey: "event_type",
      header: ({ column }) => {
        return (
          <span
            className=" flex flex-row bg-dacblue-light text-white cursor-pointer"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
            Event Type
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </span>
        );
      },
      cell: ({ row }) => (
        <div className="flex items-center gap-2 px-2 py-1 rounded-md w-fit">
            <div className={`rounded-[50%] w-3 h-3 ${row.original.event_type === "Campaign" ? 'bg-campaign-dark' : 'bg-post-dark'}`} />
          {row.original.event_type}
        </div>
      )
    },
    {
      accessorKey: "views",
      header: ({ column }) => {
        return (
          <span
            className=" flex flex-row bg-dacblue-light text-white cursor-pointer"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
            Views
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </span>
        );
      },
      cell: ({ row }) => (
        <div className="flex items-center gap-1 bg-gray-100 px-2 py-1 rounded-md w-fit">
          <TrendingUp size={12} />
          {row.original.views}
        </div>
      )
    },
    {
      accessorKey: "likes",
      header: ({ column }) => {
        return (
          <span
            className=" flex flex-row bg-dacblue-light text-white cursor-pointer"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
            Likes
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </span>
        );
      },
      cell: ({ row }) => (
        <div className="flex items-center gap-1 bg-gray-100 px-2 py-1 rounded-md w-fit">
          <Heart size={12} />
          {row.original.likes}
        </div>
      )
    },
    {
      accessorKey: "date_posted",
      header: ({ column }) => {
        return (
          <span
            className=" flex flex-row bg-dacblue-light text-white cursor-pointer"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
            Date posted
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </span>
        );
      },
      cell: ({ row }) => format(new Date(row.original.date_posted), 'MMM dd yyyy')
    },
    {
      header: "Action",
      cell: () => {
        return (
        <Button className="flex items-center text-black h-fit gap-1 bg-gray-100 hover:bg-blue-500 hover:text-white px-2 py-1 rounded-md w-fit">
          <Forward size={12} />
            View
        </Button>
      )
      },
    },
  ];
